import { ApolloError } from '@apollo/client';
import { Decimal } from 'decimal.js';
import { createContext } from 'react';

import { TypeaheadSelectInputOption } from '@/components/form/baseInputs/inputTypes';
import { useGuardedContext } from '@/hooks/useGuardedContext';

import { EstateWaterfallHypotheticalSaleLoanModal_EstateWaterfallFragment } from '../../graphql/EstateWaterfallHypotheticalSaleLoanModal.generated';
import { SaleLoanIllustration_EstateWaterfallFragment } from '../../Illustration/graphql/SaleLoanIllustration.generated';

export interface PossibleSellerLenderType
  extends TypeaheadSelectInputOption<string> {
  taxDiscount?: Decimal | null | undefined;
  effectiveDiscountPercent?: Decimal | null | undefined;
}

export interface SaleLoanFormContext {
  possibleRecipients: TypeaheadSelectInputOption<string>[];
  possibleSellerLenders: PossibleSellerLenderType[];
  saleLoanId: string | null;
  saleLoanFundingId: string | null;
  waterfallId: string;
  waterfall: EstateWaterfallHypotheticalSaleLoanModal_EstateWaterfallFragment | null;
  loading: boolean;
  error: ApolloError | undefined;
  simulatedWaterfall: SaleLoanIllustration_EstateWaterfallFragment | null;
  setSimulatedWaterfall: (
    simulatedWaterfall: SaleLoanIllustration_EstateWaterfallFragment | null
  ) => void;
}

export const SaleLoanFormContext = createContext<SaleLoanFormContext>({
  possibleRecipients: [],
  possibleSellerLenders: [],
  saleLoanId: null,
  saleLoanFundingId: null,
  waterfallId: '',
  waterfall: null,
  loading: false,
  error: undefined,
  simulatedWaterfall: null,
  setSimulatedWaterfall: () => {},
});

export const useSaleLoanFormContext = () =>
  useGuardedContext(SaleLoanFormContext, 'SaleLoanFormProvider');
